<!--  -->
<template>
  <div class="information">
    <div class="tiltle">新闻资讯</div>
    <div class="details">
      <div v-for="(item, index) in informationList" :key="index" class="every">
        <div class="rizi">{{ item.rizi }}</div>
        <div v-for="(it, index) in item.list" :key="index" class="everyOnce">
          <div>{{ it.rizi }}</div>
          <div class="tetx">{{ it.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      informationList: [
        {
          name: "",
          rizi: "2024",
          list: [
            {
              name: "杭州市委常委、秘书长、改革办主任朱华一行对“民匠有约”平台进行实地调研",
              rizi: "5月28日",
            },
            {
              name: "钱塘区党工委书记、区委书记金承涛调研“民匠有约”平台。",
              rizi: "3月13日",
            },
          ],
        },
        {
          name: "",
          rizi: "2023",
          list: [
            {
              name: "国家应急管理部安全执法和工贸监管局副局长吴俊荣等一行调研指导“民匠有约”平台建设工作。",
              rizi: "12月26日",
            },
            {
              name: "国家应急管理部新闻司二级调研员刘延鹏对“民匠有约”平台进行实地考察指导。",
              rizi: "8月31日",
            },
          ],
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.information {
  height: 652px;
  background: url("@/assets/companybg2.png") no-repeat;
  background-size: 100% 100%;
  padding: 80px 360px;
  .tiltle {
    font-weight: 500;
    font-size: 28px;
    color: #ffffff;
  }
}
.details {
  position: relative;
  margin-top: 72px;
  .every {
    position: relative;
    text-align: left;
    padding-left: 50px; /* 为圆点留出空间 */
    border-left: 1px solid #1c87ff;
    .rizi {
      color: #1c87ff;
      margin-bottom: 10px;
      font-weight: bold;
      font-size: 20px;
      color: #1c87ff;
    }
    .rizi::before {
      content: "";
      position: absolute;
      left: -4px;
      top: 0; /* 调整圆点垂直位置 */
      width: 6px;
      height: 6px;
      background-color: currentColor; /* 与文字颜色一致 */
      border-radius: 50%;
    }
  }
}
.everyOnce {
  display: flex;
  div {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
    margin: 10px 0 50px 0;
  }
  .tetx {
    margin-left: 40px;
  }
}
</style>
